import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sortedIds: [],
  entities: {},
  filters: {},
  sorter: {},
  isLoaded: false,
  isSavingActive: false,
  search: '',
  page: 1,
  pageCount: 1,
  selectedAdvertiser: null,
}

const arcAdvertisersSlice = createSlice({
  name: 'arcAdvertisers',
  initialState,
  reducers: {
    fetchArcAdvertisersSuccess: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      page: payload.page,
      pageCount: payload.pageCount,
      entities: payload.advertisers.reduce((acc, advertiser) => {
        acc[advertiser.id] = {
          ...advertiser,
          key: advertiser.id,
        }
        return acc
      }, {}),
      sortedIds: payload.sortedIds,
    }),
    fetchArcAdvertisersFailure: (state) => state,
    fetchArcAdvertiserDetailsSuccess: (state, { payload }) => ({
      ...state,
      selectedAdvertiser: payload.advertiser,
    }),
    fetchArcAdvertiserDetailsFailure: (state) => ({
      ...state,
      selectedAdvertiser: null,
    }),
    saveFiltersAndSorter: (state, { payload = {} }) => ({
      ...state,
      search: payload.search,
      filters: payload.filters || initialState.filters,
      sorter: payload.sorter || initialState.sorter,
    }),
    startSaving: (state) => ({
      ...state,
      isSavingActive: true,
    }),
    finishSaving: (state) => ({
      ...state,
      isSavingActive: false,
    }),
    clearData: () => initialState,
  },
})

export default arcAdvertisersSlice